import { render } from "./user-enumeration-protection.vue?vue&type=template&id=b939aaac"
import script from "./user-enumeration-protection.vue?vue&type=script&lang=js"
export * from "./user-enumeration-protection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__